import { apiClient } from '../client';
import type { ResaleItem } from '../../components/ResaleItem/types';
import type {
  ApiResaleItem,
  ResaleItemAvailabilityParams,
  ResaleItemAvailabilityResponse,
  ResaleItemShowResponse,
  ResaleItemsListParams,
  ResaleItemsListResponse,
} from './types';

export const resaleItemsQueryKeys = {
  all: ['resaleItems'] as const,
  lists: () => [...resaleItemsQueryKeys.all, 'list'] as const,
  list: (params?: ResaleItemsListParams) => [...resaleItemsQueryKeys.lists(), params] as const,
  details: () => [...resaleItemsQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...resaleItemsQueryKeys.details(), id] as const,
  availabilities: () => [...resaleItemsQueryKeys.all, 'availability'] as const,
  availability: (params: ResaleItemAvailabilityParams) =>
    [...resaleItemsQueryKeys.availabilities(), params] as const,
};

export async function getResaleItems(params?: ResaleItemsListParams): Promise<ResaleItemsListResponse> {
  const response = await apiClient.get<ResaleItemsListResponse>('/api/resale_items', { params });
  return response.data;
}

export async function getResaleItem(id: number): Promise<ResaleItemShowResponse> {
  const response = await apiClient.get<ResaleItemShowResponse>(`/api/resale_items/${id}`);
  return response.data;
}

export async function getResaleItemAvailability(
  params: ResaleItemAvailabilityParams,
): Promise<ResaleItemAvailabilityResponse> {
  const response = await apiClient.get<ResaleItemAvailabilityResponse>(
    '/api/resale_items/availability',
    { params },
  );
  return response.data;
}

export function mapApiResaleItemToResaleItem(api: ApiResaleItem): ResaleItem {
  return {
    id: api.id,
    name: api.name,
    vendor: api.supplier,
    recommended_retail_price: api.recommended_retail_price,
    cost_to_company: api.cost_to_company,
    item_notes: api.notes,
    delivery_information: api.delivery_information,
    max_quantity: api.max_quantity,
    images: api.images,
    created_at: api.created_at,
    active: api.active,
  };
}
